module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1CfDI"))).then(() => parcelRequire('2KbAe'));